let helper = new Object()

helper.random = () => {
  let color = '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
  return color
}

export default helper
